<div class="header flex_column">
  <div class="laptop_padding navbar">
    <div class="top_nav container flex_between_align_center">
      <div class="flex_align_center w_100">
          <img class="top_nav--logo pointer" [routerLink]="''" src="assets/images/new_logo.svg" *ngIf="!(isTablet && searchBy)">
          <div class="ml_40 catalog_button pointer flex_align_center" *ngIf="!isTablet" (click)="catlog = !catlog">
            <img [src]="'assets/images/icons/' + (catlog? 'catalog_close_icon.svg' : 'catalog_img.svg')">
            <div class="ml_8 catalog_button--text">
              {{'navbar.catalog' | translate}}
            </div>
          </div>
        <div class="search_overlay" [ngClass]="{show: searchBy}" (click)="searchBy = ''"></div>
        <div class="search_block"  [ngClass]="{'focus_in':searchBy, 'ml_0' : isTablet && searchBy}">
          <div class="search flex_align_center app_input w_100">
            <div class="icons_container">
              <img
                src="assets/images/icons/navbar/search.svg"
              >
            </div>
            <input type="text"
                   #searchInput
                   [value]="searchBy || ''"
                   [placeholder]="'input_placeholder.find_favorite_flowers' | translate"
                   (keyup)="searchFor(searchInput.value)"
            >
            <div class="search_dialog w_100" *ngIf="searchBy" #searchMenu>
              <app-search-dialog
                [searchBy]="searchBy"
              ></app-search-dialog>
            </div>
            <ng-container *ngIf="searchBy">
              <img
                (click)="searchBy = ''"
                src="assets/images/icons/navbar/x-close.svg"
                class="pointer remove_search">
            </ng-container>
          </div>
        </div>
      </div>
      <div class="ml_50 flex_align_center">
        <div class="mr_5 pointer" (click)="openBonusDialog()">
          <div class="flex_align_center">
            <span class="bonus">
              {{ bonusAmount }}
            </span>
            <img class="ml_5" src="assets/images/icons/navbar/bonus_icon.svg">
          </div>
          <div class="bonus_title mt_4">
            {{'bonus_info.title' | translate}}
          </div>
        </div>
        <div class="order_button flex_column_center pointer" *ngIf="!isTablet" (click)="navigateTo('/orders')">
          <svg width="24" height="24" viewBox="0 0 28 28"  xmlns="http://www.w3.org/2000/svg">
            <path d="M23.334 19.8364C23.334 20.5938 22.9059 21.2867 22.2285 21.6255L14.8945 25.2915C14.3315 25.573 13.6685 25.573 13.1055 25.2915L5.77246 21.6255C5.09493 21.2867 4.66702 20.5939 4.66699 19.8364V13.6958L10.8848 16.8042C11.674 17.1988 12.6334 16.9443 13.123 16.2104L14.001 14.894L14.8779 16.2104C15.3675 16.9444 16.327 17.1986 17.1162 16.8042L23.334 13.6958V19.8364ZM13.9717 11.7573L23.3232 7.13037L25.6865 10.6167L16.3311 15.2417L13.9717 11.7573L11.7031 15.2417L2.36719 10.5493L4.68555 7.1001L13.9717 11.7573ZM12.833 1.53076C14.6048 1.53076 16.0418 2.96701 16.042 4.73877C16.042 5.30677 15.8937 5.84043 15.6348 6.30322L16.3691 7.03662C16.7108 7.37833 16.7108 7.93319 16.3691 8.2749C16.0274 8.61661 15.4726 8.61661 15.1309 8.2749L14.3975 7.54053C13.9347 7.79947 13.401 7.94775 12.833 7.94775C11.0612 7.94758 9.625 6.51057 9.625 4.73877C9.62518 2.96711 11.0614 1.53094 12.833 1.53076ZM12.833 3.28076C12.0279 3.28094 11.3752 3.93361 11.375 4.73877C11.375 5.54408 12.0277 6.19758 12.833 6.19775C13.6384 6.19775 14.292 5.54418 14.292 4.73877C14.2918 3.9335 13.6383 3.28076 12.833 3.28076Z" fill="currentColor"/>
          </svg>
          <div class="middle_small_text bold_400 line_h_16 mt_4">
            {{'navbar.orders' | translate}}
          </div>
        </div>
        <div class="basket_button flex_column_center pointer" *ngIf="!isTablet" (click)="navigateTo('/basket')">
          <svg width="24" height="24" viewBox="0 0 28 28"  xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M9.78707 3.5H18.2139C20.4951 3.5 22.442 5.14926 22.8171 7.39947L24.7615 19.0661C25.2356 21.9106 23.042 24.5 20.1583 24.5H7.84263C4.95891 24.5 2.76537 21.9106 3.23945 19.0661L5.1839 7.39947C5.55893 5.14926 7.50582 3.5 9.78707 3.5ZM14.0005 12.5417C16.4167 12.5417 18.3755 10.5829 18.3755 8.16667V7C18.3755 6.51675 17.9837 6.125 17.5005 6.125C17.0172 6.125 16.6255 6.51675 16.6255 7V8.16667C16.6255 9.61641 15.4502 10.7917 14.0005 10.7917C12.5507 10.7917 11.3755 9.61641 11.3755 8.16667V7C11.3755 6.51675 10.9837 6.125 10.5005 6.125C10.0172 6.125 9.62548 6.51675 9.62548 7V8.16667C9.62548 10.5829 11.5842 12.5417 14.0005 12.5417Z"/>
          </svg>
          <div class="middle_small_text bold_400 line_h_16 mt_4">
            {{'navbar.basket.title' | translate}}
          </div>
        </div>
        <div class="favorite_button  flex_column_center pointer" *ngIf="!isTablet" (click)="navigateTo('/favorites')">
          <svg width="24" height="24" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M18.7963 3.5C22.9056 3.5 25.6667 7.41125 25.6667 11.06C25.6667 18.4494 14.2074 24.5 14 24.5C13.7926 24.5 2.33337 18.4494 2.33337 11.06C2.33337 7.41125 5.09449 3.5 9.20375 3.5C11.563 3.5 13.1056 4.69437 14 5.74437C14.8945 4.69437 16.4371 3.5 18.7963 3.5Z"/>
          </svg>
          <div class="middle_small_text bold_400 line_h_16 mt_4">
            {{'navbar.favorites' | translate}}
          </div>
        </div>
        <div class="user_img pointer"  (click)="navigateTo('/my-account')">
          <img class="w_100" src="assets/images/icons/navbar/profile_icon.svg">
        </div>
        <img class="ml_12" (click)="catlog = !catlog" [src]="'assets/images/icons/navbar/' + (catlog? 'catalog_close_tablet_icon.svg' : 'menu_Icon.svg')" *ngIf="isTablet">
      </div>
    </div>
    <div [ngClass]="{show : catlog}" class="catalog">
      <app-menu-catalog
        *ngIf="catlog"
        (navigate)="navigateTo($event)"
      ></app-menu-catalog>
    </div>
    <div class="container flex_between_align_center bottom_nav" [ngClass]="{'border_unset' : catlog && isTablet}">
      <div class="flex_align_center add_and_time">
        <div class="address_change_popup pointer" (click)="openMapOrFavoriteAddressDialog()">
          <div class="flex_align_center  position_relative">
            <div class="flex_align_center">
              <img src="assets/images/icons/navbar/address_icon.svg">
              <span class="ml_4 text_normal bold_400">
                {{'navbar.address' | translate}}
              </span>
            </div>
            <img class="ml_8 mr_8" src="assets/images/icons/navbar/ellipse.svg">
            <div class="text_normal text_color_bren_red bold_600 pointer">
              {{selectedAddressName || ('navbar.specify_address' | translate)}}
            </div>
            <div class="favorite_address_popup" *ngIf="userInfo && favoriteAddress?.length">
              <app-favorite-address
                (selectNewAddress)="openAsDialogForSelectAddress()"
                (addressListChanged)="getFavoriteAddress()"
                [type]="'popup'"
              ></app-favorite-address>
            </div>
          </div>
        </div>
<!--        <div class="delivery_date pointer" (click)="openDeliveryDateDialog()">-->
<!--          <div class="flex_align_center ml_32">-->
<!--            <div class="flex_align_center">-->
<!--              <img src="assets/images/icons/navbar/time_icon.svg">-->
<!--              <span class="ml_4 text_normal">{{'order_creation.on_time' | translate}}-->
<!--            </span>-->
<!--            </div>-->
<!--            <img class="ml_8 mr_8" src="assets/images/icons/navbar/ellipse.svg">-->
<!--            <div class="text_normal text_color_bren_red bold_600 pointer">-->
<!--              {{'order_creation.as_soon_as_possible' | translate}}-->
<!--            </div>-->
<!--            <div class="delivery_date_popup">-->
<!--              <app-delivery-date [popupData]="{slots:availableSlots ,deliverOn : deliverOn}">-->
<!--              </app-delivery-date>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="flex_align_center valentine_day pointer"
           *ngIf="selection"
           [routerLink]="'collections/' + selection.id"
      >
        <span class="ml_8 text_normal bold_400">
          {{selection.title}}
        </span>
      </div>
    </div>
  </div>
</div>
<div class="catalog_overlay" [ngClass]="{show:  catlog}" (click)="catlog = false"></div>
